'use client';

import { PropsWithChildren } from 'react';
import { SWRConfig as SWRConfigInitial } from 'swr';

import { defaultFetcher } from '@fshr/shared';

export default function SWRConfig({ children }: PropsWithChildren) {
	return (
		<SWRConfigInitial
			value={{
				fetcher: defaultFetcher,
			}}
		>
			{children}
		</SWRConfigInitial>
	);
}
